import { CommonModule } from '@angular/common';
import {
	Component,
	Input,
	OnInit,
} from '@angular/core';

import {
	BehaviorSubject,
	catchError,
	tap,
	throwError,
} from 'rxjs';


import { PopUpService } from 'ib/internetbank-core/ib-components/pop-ups/pop-up/pop-up.service';
import { RoundLoaderComponentModule } from 'ib/internetbank-core/ib-components/round-loader/round-loader.component.module';
import { ApplicationException } from 'ib/internetbank-core/ib-exceptions/ib-exceptions';

import { ConstantsService } from '../../../../common/services/constants.service';
import { OkActionResultMessageBottomComponent } from '../../../../pages/shared/form-layout/result-message/components/ressultmessage-bottom-components/ok-action.result-message.bottom.component/ok-action.result-message.bottom.component';
import { ResultMessageComponent, ResultMessageMode } from '../../../../pages/shared/form-layout/result-message/result-message.component';
import { PdfViewerContentComponentForPopupComponentComponent } from '../../../../shared/components/pdf-viewer.content-component-for-popup-component/pdf-viewer.content-component-for-popup-component';
import { SvgDocumentOneListModule } from '../../../../shared/svg/svg-document-one-list/svg-document-one-list.module';
import { GetReferenceOrderedDocumentResponce, ReferenceOrdered } from '../references.entities';
import { ReferencesFacadeService } from '../references.facade.service';

@Component({
	selector: 'app-reference-ordered',
	templateUrl: './reference-ordered.component.html',
	styleUrls: ['./reference-ordered.component.less'],
	imports: [
		SvgDocumentOneListModule,
		CommonModule,
		RoundLoaderComponentModule,
	],
})
export class ReferenceOrderedComponent implements OnInit {


	@Input()
	public reference: ReferenceOrdered;

	public documentPending$$: BehaviorSubject<boolean> = new BehaviorSubject(false);

	constructor(
		private referencesFacadeService: ReferencesFacadeService,
		private popUpService: PopUpService,
	) { }

	public ngOnInit(): void {
	}

	public showDocument(entity: ReferenceOrdered) {

		this.documentPending$$.next(true);

		this.referencesFacadeService.getReferenceOrderedDocument(entity)
			.pipe(
				catchError((error: ApplicationException) => {
					this.documentPending$$.next(false);
					const popUpComponentComponentRef = this.popUpService.open(
						ResultMessageComponent,
						{

							inputs: {
								title: 'Ошибка операции',
								text: error.message || ConstantsService.ERROR_OPERATION_UNAVAILABLE,

								mode: ResultMessageMode.FAIL,

								settingsForResultBottomComponent: {
									componentType: OkActionResultMessageBottomComponent,
									inputs: {},
									componentOnInit: (componentInstance: OkActionResultMessageBottomComponent) => { },
								},

								// closePopup: () => {
								// 	popUpComponentComponentRef.componentRef.instance.close();
								// },
							},
							unclosable: true,
						},

					);

					return throwError(() => error);
				}),
				tap((data: GetReferenceOrderedDocumentResponce) => {
					this.documentPending$$.next(false);
					this.popUpService.open(
						PdfViewerContentComponentForPopupComponentComponent,
						{
							inputs: {
								title: this.reference.referenceName,
								base64Src: data.document,
							},
						},
					)
				}),
			)
			.subscribe();

	}

}
